import React, { useState, useEffect } from 'react';
import { Skeleton } from 'antd';
import { Column } from '@ant-design/plots';

import { getPastSixMonthStats } from 'api-services/reporting';

const SubscriptionsColumnChart = () => {
  const [data, setData] = useState([]);
  const [skeleton, setSkeleton] = useState(true);

  function customSort(a, b) {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const monthA = months.indexOf(a.month);
    const monthB = months.indexOf(b.month);

    return monthA - monthB;
  }

  useEffect(() => {
    const fetchPastSixMonthStats = async () => {
      setSkeleton(true);
      const response = await getPastSixMonthStats();
      if (response.status === 200) {
        const makeData = [];
        response.data.map(({ month, sold_subscriptions, canceled_subscriptions }) => {
          makeData.push({
            month,
            amount: parseInt(sold_subscriptions, 10),
            type: 'Sold',
          });
          makeData.push({
            month,
            amount: parseInt(canceled_subscriptions, 10),
            type: 'Canceled',
          });
        });
        makeData.sort(customSort);
        setData(makeData);
      }
      setSkeleton(false);
    };

    fetchPastSixMonthStats();
  }, []);

  const config = {
    data,
    xField: 'month',
    yField: 'amount',
    isGroup: true,
    seriesField: 'type',
    label: {
      position: 'middle',
      style: {
        fill: '#FFFFFF',
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    meta: {
      type: {
        alias: '类别',
      },
      sales: {
        alias: '销售额',
      },
    },
  };

  return skeleton ? <Skeleton active /> : <Column {...config} />;
};

export default SubscriptionsColumnChart;
